<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: 'Sucursales',
        },
        {
          text: $route.params.company_id,
          link: `companies/${$route.params.company_id}/resources`,
        },
        {
          text: 'Canastas',
        },
        {
          text: isNewBasket ? 'Nueva canasta' : basket.name,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else>
      <div class="card ml-3">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group mt-1">
                <span style="font-size: 22px"
                  >Precio <b>{{ currentBasketPrice }}</b></span
                >
              </div>

              <div class="form-group">
                <label for="name">Nombre</label>
                <input
                  ref="name"
                  name="name"
                  placeholder="Nombre"
                  type="text"
                  v-model="basket.name"
                  :class="`form-control ${errors.name ? 'is-invalid' : ''}`"
                />
              </div>

              <div class="form-group">
                <label for="photo">Foto</label>
                <input
                  ref="photo"
                  name="photo"
                  placeholder="Foto"
                  type="text"
                  v-model="basket.photo"
                  :class="`form-control ${errors.photo ? 'is-invalid' : ''}`"
                />
              </div>

              <div class="form-group">
                <label for="desc">Descripción</label>
                <textarea
                  ref="description"
                  placeholder="Descripción"
                  v-model="basket.description"
                  :class="`form-control mt-1 ${
                    errors.description ? 'is-invalid' : ''
                  }`"
                  cols="40"
                  rows="2"
                ></textarea>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="text-center">
                <ImageSelectBtn
                  id="BASKET_PHOTO"
                  :uploading="uploadingPhoto"
                  :label="'Foto ' + (photoProgress ? `${photoProgress}%` : '')"
                  v-on:file-selected="setBasketPhoto"
                />
                <br />
                <div class="form-group">
                  <img
                    :src="photoPreview"
                    v-show="photoPreview != ''"
                    alt="Foto"
                    id="photoPreview"
                    class="photo-preview"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-left">
              <button
                :disabled="basket.id == ''"
                @click="deleteBasket"
                class="btn btn-danger"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- PRODUCTOS EN LA CANASTA -->
      <div class="ml-15 mt-2">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <h5>Productos de la canasta {{ productsInBasket }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <button
                  :disabled="saving"
                  @click="openModal"
                  class="btn btn-outline-success mr-2"
                >
                  <i class="fa fa-plus"></i>
                  Agregar productos
                </button>
                <button
                  :disabled="saving"
                  @click="saveBasket"
                  class="btn btn-success"
                >
                  <span v-if="!saving">
                    <i class="fa fa-save"></i>
                    Guardar cambios
                  </span>
                  <span v-else>
                    <i class="fa fa-spinner fa-spin"></i>
                    Guardando
                  </span>
                </button>
              </div>
            </div>

            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th colspan="2">Nombre</th>
                  <th class="text-center">Precio</th>
                  <th class="text-center">Cantidad</th>
                  <th class="text-center">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in basketProducts" :key="x.id">
                  <td>
                    <img
                      :src="x.photo || '/logo_blue.png'"
                      alt="Foto del producto"
                      class="img-rounded img-responsive"
                      style="height: 50px"
                    />
                  </td>
                  <td>{{ x.name }}</td>
                  <td class="text-center">{{ x.price }}</td>
                  <td>
                    <input
                      type="number"
                      max="20"
                      min="1"
                      v-model="x.quantity"
                      style="width: 70px; margin: 0 auto"
                      class="form-control"
                    />
                  </td>
                  <td class="text-center">
                    <a href="#" @click="removeProduct(x)"
                      ><i class="fa fa-close text-danger fa-2x"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE PRODUCTOS -->
    <div
      class="modal fade"
      id="basket-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg"
        style="max-width: 1000px"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="row" style="width: 100%">
              <div class="col-sm-10">
                <h4 style="margin: 0">Agregar productos a la canasta</h4>
              </div>
              <div class="col-sm-2">
                <button
                  style="padding: 1rem 0 0 0 !important"
                  class="close close-modal-custom"
                  @click="closeModal()"
                >
                  <span aria-hidden="true">
                    <i class="fa fa-close"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div style="display: flex; align-items: center">
                  <input
                    @keydown.enter="searchProducts"
                    type="text"
                    placeholder="Nombre del producto (Enter para buscar)"
                    v-model="filter"
                    class="form-control"
                  />
                  <button
                    @click="searchProducts"
                    class="btn btn-primary btn-sm"
                  >
                    Buscar
                  </button>
                </div>

                <div style="overflow-y: auto; max-height: 50vh" class="mt-1">
                  <table class="table">
                    <thead class="thead-light">
                      <tr>
                        <th colspan="2">Nombre</th>
                        <th class="text-center">Precio</th>
                        <th class="text-center">Cantidad</th>
                        <th class="text-center">Agregar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="x in products"
                        :key="x.id"
                        :class="x.selected ? 'seleccionado' : ''"
                      >
                        <td>
                          <img
                            :src="x.photo"
                            alt="Foto del producto"
                            class="img-rounded img-responsive"
                            style="height: 50px"
                          />
                        </td>
                        <td>{{ x.name }}</td>
                        <td class="text-center">
                          {{ $helpers.asMoney(x.price) }}
                        </td>
                        <td>
                          <input
                            type="number"
                            max="20"
                            min="1"
                            v-model="x.quantity"
                            style="width: 70px; margin: 0 auto"
                            class="form-control"
                          />
                        </td>
                        <td class="text-center">
                          <a
                            @click="addToBasket(x)"
                            href="#"
                            class="text-success"
                          >
                            <i class="fa fa-plus-circle fa-2x"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="loadingProducts" class="text-center mt-2 pt-3">
                  Cargando productos<br />
                  <Loader />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row" style="width: 100%">
              <div class="col-sm-12 text-right">
                <button
                  :disabled="loading"
                  @click="closeModal"
                  class="btn main-green-bg ml-2"
                >
                  <i class="fa fa-save"></i>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =========== -->
  </div>
</template>

<script>
import Breadcrumbs from "../components/Breadcrumbs";
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import ImageSelectBtn from "../components/ImageSelectBtn";
import PhotoUploader from "../../commons/PhotoUploader";

export default {
  name: "BasketDetail",
  components: {
    Breadcrumbs,
    Loader,
    ImageSelectBtn,
  },
  data: function () {
    return {
      loading: false,
      companyService: new CompanyService(),
      basketProducts: [],
      modalOptions: {
        keyboard: false,
        backdrop: false,
      },
      editing: false,
      basket: {
        id: "",
        name: "",
        photo: "",
        photoPreview: "",
        status: 1,
        description: "",
        photoRef: "",
        loading: false,
        price: "0.00",
        available: false,
      },
      errors: {
        name: false,
        description: false,
      },
      filter: "",
      products: [],
      productsLoaded: false,
      loadingProducts: false,
      basketPhotoUploadProgress: "",
      isNewBasket: false,
      saving: false,
      photoFile: null,
      photoPreview: "",
      photoProgress: "",
      uploadingPhoto: false,
    };
  },
  methods: {
    async setBasketPhoto(data) {
      this.uploadingPhoto = true;
      this.photoFile = data.file;
      this.photoPreview = data.preview;
      this.basket.photo = data.preview;
      const idRef = this.basket.id ? this.basket.id : `NUEVA_${Date.now()}`;
      const image = await PhotoUploader.upload(
        "Baskets",
        idRef,
        data.file,
        (progress) => {
          this.photoProgress = progress;
        }
      );
      this.photoProgress = "";
      this.basket.photo = image.url;
      this.uploadingPhoto = false;
    },
    addToBasket(product) {
      if (Number(product.quantity) < 1) {
        this.$helpers.toast(
          "La cantidad debe ser mayor o igual a 1",
          "warning"
        );
        return;
      }
      this.basketProducts.push(Object.assign({}, product));
      this.products.splice(
        this.products.findIndex((x) => x.id === product.id),
        1
      );
    },
    async removeProduct(product) {
      this.basketProducts.splice(
        this.basketProducts.findIndex((x) => x.id === product.id),
        1
      );
    },
    async searchProducts() {
      if (this.filter == "" || this.$route.params.company_id == "") {
        return;
      }
      this.loadingProducts = true;
      this.products = [];
      const resp = await this.companyService.getCompanyProducts(
        this.$route.params.company_id,
        true,
        this.filter
      );
      if (resp.ok) {
        resp.data.forEach((x) => {
          x.selected = false;
          x.quantity = 0;
        });
        this.products = resp.data;
      } else {
        this.$helpers.message("Error", resp.message, "error");
      }

      this.loadingProducts = false;
    },
    openModal() {
      $("#basket-modal").modal({
        keyboard: false,
        backdrop: false,
      });
    },
    managePhoto(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.basket.photo = files[0];
      this.basket.photoPreview = URL.createObjectURL(files[0]);
    },
    triggerPhotoChange() {
      $("#basket-photo").trigger("click");
    },
    async saveBasket() {
      if (this.basket.name == "") {
        this.$helpers.toast("El nombre es requerido", "warning");
        this.$refs.name.focus();
        this.errors.name = true;
        return;
      }
      this.errors.name = false;

      if (this.basket.description == "") {
        this.$helpers.toast("La descripción es requerida", "warning");
        this.$refs.description.focus();
        this.errors.description = true;
        return;
      }
      this.errors.description = false;

      if (this.basketProducts.length == 0) {
        this.$helpers.toast("Debes seleccionar al menos 1 producto", "warning");
        return;
      }

      if (this.basket.id) {
        const confirmed = await this.$helpers.confirm(
          "Estas apunto de modiificar esta canasta"
        );
        if (!confirmed) {
          return;
        }
      }

      this.saving = true;

      try {
        const response = await this.companyService.saveBasket(
          this.$route.params.company_id,
          this.basket.id,
          this.basket.name,
          this.basket.description,
          this.basketProducts,
          this.basket.photo,
          (uploadProgress) => {
            this.basketPhotoUploadProgress = uploadProgress;
          }
        );

        if (response.ok) {
          this.$helpers.message("Operación exitosa", "Datos guardados");

          this.basketPhotoUploadProgress = "";
          this.name = "";
          this.description = "";
          this.basketProducts = [];

          this.$router.push(
            `/companies/${this.$route.params.company_id}/resources`
          );
        } else {
          throw new Error(response.message);
        }
      } catch (e) {
        console.log("ERR >> ", e);
        this.$helpers.message("Error", e.message, "error");
      }
      this.saving = false;
    },
    async deleteBasket() {
      const ok = await this.$helpers.confirm(
        "La canasta dejara de aparecer en la app"
      );
      if (ok) {
        const res = await this.companyService.deleteBasket(
          this.$route.params.company_id,
          this.basket.id
        );
        if (res.ok) {
          this.$helpers.toast("La canasta se eliminó", "success");
          this.$router.push(
            `/companies/${this.$route.params.company_id}/resources`
          );
        } else {
          this.$helpers.message("Error", res.message, "error");
        }
      }
    },
    edit: async function (basket) {
      basket.loading = true;
      try {
        await this.getProducts();
        this.editing = true;
        this.basket.id = basket.id;
        this.basket.name = basket.name;
        this.basket.status = basket.status;
        this.basket.photoPreview = basket.photo;
        this.basket.description = basket.description;
        this.basket.photoRef = basket.photoRef;

        let _products = await this.db
          .collection("Basket")
          .where("category_id", "==", basket.id)
          .get();

        let d = null;
        _products = _products.docs.map((p) => {
          d = p.data();
          return {
            id: d.product_id,
            quantity: d.quantity,
          };
        });

        this.products.forEach((product) => {
          _products.forEach((basket) => {
            if (basket.id == product.id) {
              product.selected = true;
              product.quantity = basket.quantity;
            }
          });
        });
        $("#basket-modal").modal(this.modalOptions);
      } catch (error) {
        console.log(error);
        this.$helpers.message("Oops", "Algo salio mal", "error");
      }
      basket.loading = false;
    },
    closeModal: function () {
      this.products = [];
      this.filter = "";

      $("#basket-modal").modal("hide");
    },
  },
  beforeMount: async function () {
    if (this.$route.params.company_id == "") {
      this.$helpers.message("Error", "La sucursal no existe", "error");
      return;
    }

    if (this.$route.params.basket_id == 0) {
      this.isNewBasket = true;
      return;
    }

    this.basket.id = this.$route.params.basket_id;
    this.loading = true;
    const res = await this.companyService.getBasket(
      this.$route.params.company_id,
      this.$route.params.basket_id
    );
    if (res.ok) {
      this.basket = res.data;
      this.photoPreview = res.data.photo;
    } else {
      this.$helpers.message("Error", res.message, "error");
    }
    const productsRes = await this.companyService.getBasketProducts(
      this.$route.params.company_id,
      this.$route.params.basket_id
    );
    if (productsRes.ok) {
      this.basketProducts = productsRes.data;
    } else {
      this.$helpers.message("Error", productsRes.message, "error");
    }
    this.loading = false;
  },
  computed: {
    productsInBasket() {
      return `(${this.basketProducts.length})`;
    },
    currentBasketPrice() {
      return Number(
        this.basketProducts.reduce(
          (a, b) => a + Number(b.price) * Number(b.quantity || 0),
          0
        )
      ).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.pic {
  text-align: center;
  img {
    height: 174px;
    width: auto;
  }
}
th,
td {
  font-weight: 400;
}
#photoPreview {
  height: 210px;
}
</style>
